import {
    appConfig as packageAppConfig,
    IConfig,
} from 'srs.sharedcomponents/lib/esm/config/app.config';
import { t as baseT } from 'i18next';
import { i18nNamespaces as namespace } from 'srs.sharedcomponents/lib/esm/i18n/i18n';
import coreSrsPrimaryOverride from '../i18n/coreSrsPrimaryOverride.json';

const translate = (
    key: string,
    nameSpaceOrOptions?: string | Record<string, string>,
    maybeOptions?: Record<string, string>
): string => {
    if (typeof nameSpaceOrOptions === 'string') {
        return baseT(key, { ...(maybeOptions || {}), ns: nameSpaceOrOptions });
    }

    const getCurrentLanguage = (): string => {
        const storedLang = localStorage.getItem('i18nextLng');
        if (storedLang) return storedLang;

        const browserLang = navigator.language;
        if (browserLang) return browserLang;

        return 'en_US';
    };

    const currentLang = getCurrentLanguage();
    const overrideTranslations =
        coreSrsPrimaryOverride[
            currentLang as keyof typeof coreSrsPrimaryOverride
        ];

    if (
        overrideTranslations &&
        overrideTranslations[key as keyof typeof overrideTranslations]
    ) {
        return overrideTranslations[
            key as keyof typeof overrideTranslations
        ] as string;
    }

    const fallbackTranslations = coreSrsPrimaryOverride['en_US'];
    if (
        fallbackTranslations &&
        fallbackTranslations[key as keyof typeof fallbackTranslations]
    ) {
        return fallbackTranslations[
            key as keyof typeof fallbackTranslations
        ] as string;
    }

    return baseT(key, {
        ...(nameSpaceOrOptions || {}),
        ns: namespace.coreSrsPrimary,
    });
};

export const appConfig: IConfig = {
    ...packageAppConfig,
    disableContinueShoppingButton: true,
    disableWishListButton: true,
    disableLeftNavForProductListCatalogue: false,
    wishListButtonRoutes: ['/'],
    categoryConfig: [{ category: 'Keys', redirectUrl: '/keyfinder' }],
    toolsItems: [
        {
            label: 'serviceSupport.menu4.item1',
            value: 'new-&-trending-initiatives',
            id: 'trendingInitiatives',
            url: '/pages/new-trending-initiatives',
        },
        {
            label: 'serviceSupport.menu4.item2',
            value: 'electric-vehicle-competency',
            id: 'evCompetency',
            url: '/pages/electric-vehicle-competency',
        },
        {
            label: 'serviceSupport.menu4.item3',
            value: 'facilities-planning',
            id: 'facilitiesPlanning',
            url: '/pages/facilities-planning',
        },
        {
            label: 'serviceSupport.menu4.item4',
            value: 'equipment-assessment',
            id: 'equipmentAssesment',
            url: '/pages/equipment-assessment',
        },
        {
            label: 'serviceSupport.menu4.item5',
            value: 'finance-terms',
            id: 'financeTerms',
            url: 'https://image.email.fordrotunda.com/lib/fe3511737164047f711c70/m/1/a1dfaa89-60f7-4708-ac27-24bea228f51c.pdf',
            openInNewTab: true,
        },
        {
            label: 'serviceSupport.menu4.item6',
            value: 'tool-storage',
            id: 'toolStorage',
            url: '/pages/tool-storage',
        },
        {
            label: 'serviceSupport.menu4.item7',
            value: 'rotunda-proving-ground',
            id: 'rotundaProvingGround',
            url: 'https://www.flipsnack.com/65DF86FF8D6/2026-rotunda-proving-ground',
            openInNewTab: true,
        },
    ],
    supportItems: [
        {
            label: 'serviceSupport.menu3.item2',
            value: 'find-my-service-optimization-manager',
            id: 'salesRep',
            url: '/service-support?expanded=find-my-service-optimization-manager',
        },
        {
            label: 'serviceSupport.menu3.item4',
            value: 'faq',
            id: 'faq',
            url: '/service-support?expanded=faq',
        },
        {
            label: 'serviceSupport.menu3.item3',
            value: 'order-history',
            id: 'orderHistory',
            url: '/orderHistory',
        },
        {
            label: 'serviceSupport.menu3.item1',
            value: 'contact-us',
            id: 'contactUs',
            url: '/service-support?expanded=contact-us',
        },
        {
            label: 'serviceSupport.menu3.item5',
            value: 'policies',
            id: 'policies',
            url: '/service-support?expanded=policies',
        },
    ],
    productTypeLabels: {
        29: 'txtServicePartNumber',
    },
};
